<template>
  <div class="projects-gallery">
    <router-link class="router project-card" to="/slide" v-for="(project, index) in projets" :key="index" 
                 :style="{'--delay': index * 0.1 + 's'}">
      <div class="card-inner">
        <div class="imageP">
          <img :src="project.image" :alt="project.name">
          <div class="overlay">
            <span class="view-text">View Project</span>
          </div>
        </div>
        <div class="Title">{{project.name}}</div>
        <div class="project-number">{{ String(index + 1).padStart(2, '0') }}</div>
      </div>
    </router-link>
  </div>
</template>

<script>
import black from "../assets/black.png";
export default {
  name: 'Projects',
  data(){
    return{
      projets:[
        {
          name: "Deer on the Run",
          image: black,
        },
        {
          name: "Creative Vision",
          image: black,
        },
        {
          name: "Artistic Journey",
          image: black,
        }
      ]
    }
  },
  mounted(){
    console.log(this.projets[0].name);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face {
  font-family: lov;
  src: url(../assets/TheFrankline.ttf);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(60px) rotateX(20deg);
  }
  to {
    opacity: 1;
    transform: translateY(0) rotateX(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.projects-gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 20px 40px;
  max-width: 100%;
  height: calc(100vh - 200px);
  margin: 0 auto;
  perspective: 1000px;
}

.router {
  text-decoration: none;
  color: inherit;
}

.project-card {
  flex: 0 1 calc(33.333% - 30px);
  min-width: 280px;
  max-width: 380px;
  animation: slideUp 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) backwards;
  animation-delay: var(--delay);
}

.card-inner {
  position: relative;
  cursor: pointer;
  transition: all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  background: linear-gradient(135deg, rgba(244, 241, 234, 0.4) 0%, rgba(232, 227, 218, 0.3) 100%);
  border-radius: 20px;
  padding: 18px;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(139, 115, 85, 0.15);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(212, 175, 55, 0.1);
}

.card-inner:hover {
  transform: translateY(-15px) scale(1.02);
  box-shadow: 
    0 20px 60px rgba(61, 90, 128, 0.3),
    0 0 0 2px rgba(61, 90, 128, 0.2),
    inset 0 1px 0 rgba(212, 175, 55, 0.2);
  background: linear-gradient(135deg, rgba(244, 241, 234, 0.6) 0%, rgba(232, 227, 218, 0.5) 100%);
  border-color: rgba(61, 90, 128, 0.3);
  animation: float 3s ease-in-out infinite;
}

.imageP {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  aspect-ratio: 4/3;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.imageP img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  filter: grayscale(30%) brightness(0.85) contrast(1.1);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(61, 90, 128, 0.88) 0%, rgba(93, 78, 55, 0.85) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.5s ease;
}

.view-text {
  color: #f4f1ea;
  font-family: 'Quarrel', cursive;
  font-size: 28px;
  font-weight: normal;
  letter-spacing: 1px;
  text-transform: none;
  transform: translateY(20px);
  transition: all 0.5s ease;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

.card-inner:hover .overlay {
  opacity: 1;
}

.card-inner:hover .view-text {
  transform: translateY(0);
}

.card-inner:hover .imageP img {
  transform: scale(1.15) rotate(2deg);
  filter: grayscale(0%) brightness(1.1) contrast(1.2);
}

@font-face {
  font-family: 'Quarrel';
  src: url(../assets/LoversQuarrel-Regular.ttf);
}

.Title {
  font-family: 'Quarrel', cursive;
  font-size: 40px;
  line-height: 1.2;
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
  position: relative;
  padding-left: 15px;
  margin-bottom: 10px;
  color: #3d5a80;
}

.Title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 0;
  background: linear-gradient(180deg, #3d5a80, #5d4e37);
  transition: height 0.5s ease;
  border-radius: 2px;
}

.card-inner:hover .Title {
  color: #5d4e37;
  transform: translateX(10px);
  text-shadow: 
    0 0 10px rgba(93, 78, 55, 0.3),
    1px 1px 4px rgba(0, 0, 0, 0.3);
}

.card-inner:hover .Title::before {
  height: 100%;
}

.project-number {
  position: absolute;
  top: 28px;
  right: 28px;
  font-size: 65px;
  font-weight: bold;
  color: rgba(139, 115, 85, 0.08);
  font-family: 'Arial', sans-serif;
  line-height: 1;
  transition: all 0.5s ease;
  z-index: 0;
}

.card-inner:hover .project-number {
  color: rgba(61, 90, 128, 0.15);
  transform: scale(1.1) rotate(-5deg);
}

/* Tablet */
@media (max-width: 1024px) {
  .projects-gallery {
    gap: 50px;
    padding: 100px 30px 60px;
  }
  
  .project-card {
    flex: 0 1 calc(50% - 25px);
  }
  
  .Title {
    font-size: 38px;
  }
  
  .project-number {
    font-size: 70px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .projects-gallery {
    gap: 40px;
    padding: 80px 25px 50px;
  }
  
  .project-card {
    flex: 0 1 100%;
    max-width: 500px;
  }
  
  .Title {
    font-size: 42px;
  }
  
  .view-text {
    font-size: 20px;
  }
  
  .project-number {
    font-size: 60px;
    top: 30px;
    right: 30px;
  }
}

@media (max-width: 480px) {
  .projects-gallery {
    gap: 35px;
    padding: 60px 20px 40px;
  }
  
  .card-inner {
    padding: 20px;
  }
  
  .Title {
    font-size: 32px;
  }
  
  .view-text {
    font-size: 18px;
  }
  
  .project-number {
    font-size: 50px;
    top: 25px;
    right: 25px;
  }
  
  .card-inner:hover {
    transform: translateY(-8px) scale(1.01);
  }
}

@media (max-width: 375px) {
  .Title {
    font-size: 28px;
  }
  
  .projects-gallery {
    padding: 50px 15px 30px;
  }
  
  .project-number {
    font-size: 45px;
  }
}
</style>
